<template>
    <div class="contact-form" ref="root">
        <form class="contactform__form" :action="getTecpageApiUrl + '/form'" method="post">
            <div class="contactform__form-content">
                <div class="contactform__form-col--left">
                    <div class="contactform__form-hidden-fields">
                        <div class="form-group mb-0">
                            <input
                                class="form-control bg-color-input color-input hidden contact-form__referrer"
                                name="referrer"
                                type="hidden"
                                :value="getUserDomain"
                            />
                        </div>
                        <div class="form-group mb-0">
                            <input
                                class="form-control bg-color-input color-input hidden contact-form__module_id"
                                name="module_id"
                                type="hidden"
                                :value="moduleId"
                            />
                        </div>
                    </div>

                    <div class="contactform__form-active-fields">
                        <div class="form-group">
                            <div class="select-wrap">
                                <select
                                    class="form-control bg-color-input color-input contact-form__salutation"
                                    name="salutation"
                                >
                                    <option value="">Anrede</option>
                                    <option value="keine Angaben">keine Angaben</option>
                                    <option value="Frau">Frau</option>
                                    <option value="Herr">Herr</option>
                                </select>
                                <div class="arrow border-color"></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-control-label color-input">Name*</label>
                            <input
                                class="form-control bg-color-input color-input contact-form__name"
                                name="name"
                                value=""
                                type="text"
                                required
                            />
                        </div>
                        <div class="form-group">
                            <label class="form-control-label color-input">E-Mail-Adresse*</label>
                            <input
                                class="form-control bg-color-input color-input contact-form__email"
                                name="email"
                                value=""
                                type="email"
                                required
                            />
                        </div>
                        <div class="form-group">
                            <label class="form-control-label color-input">Telefonnummer</label>
                            <input
                                class="form-control bg-color-input color-input contact-form__phone"
                                name="phone"
                                value=""
                                type="text"
                                pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                            />
                        </div>
                        <div class="form-group">
                            <label class="form-control-label color-input">Betreff</label>
                            <input
                                class="form-control bg-color-input color-input contact-form__subject"
                                name="subject"
                                value=""
                                type="text"
                            />
                        </div>
                        <div class="form-group">
                            <input
                                type="text"
                                name="topfhonig1"
                                value=""
                                tabindex="-1"
                                autocomplete="impp"
                            />
                            <input
                                type="text"
                                name="topfhonig2"
                                value=""
                                tabindex="-1"
                                autocomplete="impp"
                            />
                            <input
                                type="text"
                                name="topfhonig3"
                                value=""
                                tabindex="-1"
                                autocomplete="impp"
                            />
                        </div>
                    </div>
                </div>

                <div class="contactform__form-col--right">
                    <div class="form-group">
                        <label class="form-control-label color-input">Nachricht an uns*</label>
                        <textarea
                            class="form-control bg-color-input color-input contact-form__message"
                            name="message"
                            required
                        ></textarea>
                    </div>

                    <div class="contactform__custom-badge custom-badge flex--wrap"></div>

                    <div class="contactform__privacy-text module__text font-p color-p module__cms">
                        Ihre personenbezogenen Daten verarbeiten wir gemäß Art.&nbsp;6 Abs.&nbsp;1
                        S.&nbsp;1 lit.&nbsp;b DSGVO zur Bearbeitung Ihrer Anfrage. Weitere
                        Informationen zu unserem Umgang mit personenbezogenen Daten, insbesondere zu
                        Ihren Rechten als betroffene Person, finden Sie in unseren
                        <router-link
                            v-bind:to="getPrivacyLink"
                            :target="getPrivacyTarget"
                            :class="'font-bold module__link--underlined'"
                            >Datenschutzinformationen</router-link
                        >.
                    </div>
                </div>
            </div>

            <div class="contactform__cta module__cta">
                <input
                    class="contactform__submit contactform__cta-btn module__cta-btn font-button color-button bg-color-button"
                    type="submit"
                    name="submit"
                    value="Absenden"
                />
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from '@/external/modules/Form';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['getTecpageApiUrl', 'getUserDomain', 'editorMode', 'getPageUrlFromSlug']),
        getPrivacyLink() {
            return this.getPageUrlFromSlug('/datenschutz') || '';
        },
        getPrivacyTarget() {
            return this.editorMode ? '_self' : '_blank';
        }
    },
    created() {},
    mounted() {
        if (this.editorMode) {
            let i = new Form();
            i.init(this.$refs.root);
        }
    },
    props: {
        moduleId: null
    }
};
</script>
